/**
 * Builds an absolute URL path from a route config's fullPath segments,
 * with optional dynamic suffixes (e.g. an entity ID).
 */
export function buildRoutePath(route: { fullPath: readonly string[] }, ...suffixes: string[]): string {
  return '/' + [...route.fullPath, ...suffixes].join('/');
}
